module.exports = require('date-fns/endOfMonth').endOfMonth;
